<script setup>
import ChatResults from './ChatResults.vue';
import ChatResultsError from './ChatResultsError.vue';
import ChatSearchStarted from './ChatSearchStarted.vue';
import { shallowRef } from 'vue';

const props = defineProps({
	message: {
		type: Object,
		required: true
	}
});

const startedContent = shallowRef({ name: props.message.content.name, arguments: props.message.content?.arguments || {} });

const showSearchStarted = computed(() =>
	startedContent.value?.name !== 'filterFlightSearch'
);

const flightResults = computed(() => {
	const output = props.message.content?.output;
	if (props.message.type !== 'mcp_call_completed' || !output?.responseId) {
		return null;
	}
	return {
		responseId: output.responseId,
		sorting: output.sorting,
		filters: output.filters || {}
	};
});

const isError = computed(() => props.message?.content?.output?.error);
</script>

<template>
  <div class="message-wrapper assistant">
    <div class="w-full">
      <ChatSearchStarted
        v-if="showSearchStarted"
        :content="startedContent"
      />

      <ChatResults
        v-if="!isError"
        :response-id="flightResults?.responseId"
        :sorting="flightResults?.sorting"
        :filters="flightResults?.filters"
      />

      <ChatResultsError
        v-if="isError"
        :error-message="message.content.output.error"
      />
    </div>
  </div>
</template>
